import { Button, Icon } from '@platform/components';

type NeedHelpButtonProps = {
  onClick: () => void;
  isOpen: boolean;
  helpContent: string;
};

export const NeedHelpButton = (props: NeedHelpButtonProps) => {
  const { onClick, isOpen, helpContent } = props;
  return (
    <div className='flex flex-col border border-gray-100 rounded-md -mt-6'>
      <Button
        additionalClassnames={`px-4 py-1 w-full !bg-gray-50 h-[50px] !rounded-md !border-none !shadow-none !ring-none' ${isOpen ? '!rounded-b-none' : ''}`}
        variant='secondary-gray'
        size='sm'
        onPress={onClick}
      >
        <div className='w-full flex flex-row justify-between items-center text-md text-gray-500 font-medium'>
          Need help? See an example <Icon type={isOpen ? 'chevron-up' : 'chevron-down'} size='18' />
        </div>
      </Button>
      {isOpen && helpContent && (
        <div className='p-4 text-md text-gray-700 border-t border-t-gray-100'>{helpContent}</div>
      )}
    </div>
  );
};
